import React from "react";
import ButtonOrang from "./ButtonOrang";

export default function CardEcosistema({ icon, title, description, link }) {
  return (
    <div className="flex justify-center items-center w-full h-full">
      <div className="flex flex-col mt-[58px] items-center justify-start bg-sidom-light dark:bg-sidom-blue rounded-2xl border border-sidom-orange w-[350px] h-[506px] p-2 shadow-md relative overflow-visible">
        <div className="relative  w-full h-[100px] flex justify-center">
          <img
            src={icon}
            alt={`Icono ${title}`}
            className="w-48 h-42 object-contain absolute -top-20 left-1/2  inset-shadow-sm inset-shadow-indigo-500 -translate-x-1/2"
          />
        </div>

        <div className="flex flex-col justify-center items-center   leading-[1.3] px-4 h-full">
          <div className="flex flex-col justify-start mt-6  text-left items-start flex-1">
            <h1 className="text-2xl   text-left  p-3  w-full font-black text-sidom-orange">
              {title}
            </h1>
            <p className="text-sidom-dark  text-left p-2 dark:text-sidom-light text-base">
              {description}
            </p>
          </div>

          <div className="mt-2 mb-4 w-full flex justify-center items-center">
            <ButtonOrang
              text={`  + info`}
              background="bg-sidom-orange "
              textColor="text-sidom-light"
              link={link}
              bloke={true}
              width="w-[200px]"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
